import React from "react";
import styles from "./UserAgreement.module.css";

export default function UserAgreement() {
    return (
        <div className={styles.page}>
            <div className={styles.wrap}>
                <h1 className={styles.title}>Пользовательское соглашение</h1>
                <button
                    className={styles.back}
                    onClick={() => (window.location.href = "/")}
                >
                    ← На главную
                </button>

                <article className={styles.sheet}>
                <div className={styles.card}>
                    <p className={styles.text}>
                        Настоящее Пользовательское соглашение (далее — «Соглашение») является публичной офертой
                        ООО «AI Mir» (далее — «Компания», «мы») и определяет условия использования веб-сервиса
                        aimir.tech (далее — «Сервис»). Используя Сервис, вы подтверждаете принятие условий
                        Соглашения в полном объёме.
                    </p>
                </div>

                <section className={styles.card}>
                    <h2 className={styles.h2}>1. Присоединение к Соглашению</h2>
                    <p className={styles.text}>
                        Фактом присоединения является регистрация, загрузка документов, оплата или иное использование
                        функционала. Если вы не согласны с условиями, прекратите использование Сервиса.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>2. Услуги</h2>
                    <p className={styles.text}>
                        Сервис предоставляет доступ к инструментам анализа договоров с помощью алгоритмов
                        искусственного интеллекта. Результаты анализа носят информационный и справочный характер,
                        не являются юридическим заключением и не подменяют консультацию квалифицированного юриста.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>3. Ограничения</h2>
                    <p className={styles.text}>
                        Запрещено использовать Сервис в целях нарушения закона, а также загружать материалы,
                        содержащие персональные данные третьих лиц без законного основания, сведения, нарушающие
                        права и интересы других лиц, вредоносный код. Пользователь обязуется не предпринимать
                        действий, направленных на нарушение работы Сервиса, обход технических ограничений,
                        декомпиляцию, реверс-инжиниринг. Компания вправе блокировать доступ при нарушении
                        Соглашения без компенсации.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>4. Регистрация и аккаунт</h2>
                    <p className={styles.text}>
                        При регистрации вы обязуетесь указывать достоверные данные и поддерживать их актуальность.
                        Вы несёте ответственность за сохранность логина и пароля. Все действия, совершённые
                        в аккаунте, считаются совершёнными вами. Компания может ограничить либо прекратить доступ
                        при нарушении условий или по требованиям закона.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>5. Интеллектуальная собственность</h2>
                    <p className={styles.text}>
                        Исключительные права на программное обеспечение, дизайн, базы данных и иные элементы
                        Сервиса принадлежат Компании либо правообладателям по лицензии. Пользователю предоставляется
                        ограниченная неисключительная лицензия на использование Сервиса строго в пределах его
                        функционала. Любое копирование, распространение и/или модификация компонентов Сервиса
                        без согласия Компании запрещены.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>6. Персональные данные</h2>
                    <p className={styles.text}>
                        Обработка персональных данных осуществляется в соответствии с Политикой конфиденциальности
                        и Политикой обработки данных.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>7. Платные функции и расчёты</h2>
                    <p className={styles.text}>
                        Стоимость, порядок оплаты и объём предоставляемых услуг указываются на сайте/в интерфейсе
                        Сервиса. Платежи обрабатываются платёжным провайдером; реквизиты карты не хранятся на
                        серверах Компании. Возвраты средств возможны в случаях и порядке, указанных в оферте тарифа
                        / на странице оплаты.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>8. Ответственность и гарантии</h2>
                    <p className={styles.text}>
                        Сервис предоставляется «как есть». Мы не гарантируем абсолютную точность, полноту и
                        пригодность результатов анализа для любых целей. Компания не отвечает за убытки, возникшие
                        вследствие использования либо невозможности использования Сервиса, за исключением случаев
                        умысла и грубой неосторожности. Максимальная совокупная ответственность Компании перед
                        пользователем ограничена суммой платежей, фактически уплаченных за последние 3 месяца
                        использования платных функций.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>9. Контент и документы пользователя</h2>
                    <p className={styles.text}>
                        Вы сохраняете права на собственные документы. Загружая материалы, вы подтверждаете наличие
                        необходимых прав для их использования в Сервисе. Вы предоставляете Компании ограниченную
                        лицензию на обработку файлов исключительно для целей выполнения функций Сервиса.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>10. Изменения условий</h2>
                    <p className={styles.text}>
                        Компания может изменять Соглашение. Новая редакция публикуется на сайте и вступает в силу
                        с момента размещения, если не указано иное. Продолжение использования Сервиса означает
                        согласие с изменениями.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>11. Применимое право и споры</h2>
                    <p className={styles.text}>
                        К Соглашению применяется право Российской Федерации. Споры рассматриваются в суде по месту
                        нахождения Компании, если иное не предусмотрено императивными нормами.
                    </p>
                </section>

                <section className={styles.card}>
                    <h2 className={styles.h2}>12. Контакты</h2>
                    <p className={styles.text}>
                        ООО «AI Mir»<br />
                        Адрес: Москва, ул. малая дмитровка 13<br />
                        Email: support@aimir.tech
                    </p>
                    <p className={styles.update}>Последнее обновление: 29.09.2025</p>
                </section>
                </article>
            </div>
        </div>
    );
}
